import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { CircularProgress, makeStyles, Typography } from '@material-ui/core'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import { FormattedMessage } from 'react-intl'
import { Button } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'
import { STUDENT_URL } from '../../_state/helpers'

const useStyles = makeStyles((theme) => ({
    qrWrapper: {
        marginTop: 24,
        padding: 12,
        backgroundColor: '#fff',
        borderRadius: 8,
        border: '1px solid #eee',
        display: 'inline-block',
    },
    qrHint: {
        marginTop: 8,
        fontSize: 12,
        color: '#8E8E93',
        textAlign: 'center',
    },
}))

const UserAccessCodeModal = ({ isOpen, onClose, title, description, userId, user }) => {
    const classes = useStyles()
    const textAreaRef = useRef(null)

    const accessCode = user.lastUserAccessCode?.accessCode
    const loginUrl = accessCode ? `${STUDENT_URL}login/?accessCode=${accessCode}` : ''

    const handleCopyOnboardingUrl = () => {
        if (loginUrl) {
            navigator.clipboard.writeText(loginUrl)
        }
    }

    return (
        <div>
            <Dialog open={isOpen} onClose={onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{description}</DialogContentText>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}>
                        {user.isFetchingUserAccessCode && <CircularProgress size={40} />}
                        {user.lastUserAccessCode?.userId == userId && (
                            <React.Fragment>
                                <div style={{ width: '300px', fontSize: '40px', textAlign: 'center', fontFamily: 'monospace', letterSpacing: 4 }}>
                                    {accessCode}
                                </div>

                                {loginUrl && (
                                    <div className={classes.qrWrapper}>
                                        <QRCodeSVG
                                            value={loginUrl}
                                            size={200}
                                            level="M"
                                            includeMargin={false}
                                        />
                                    </div>
                                )}

                                <Typography className={classes.qrHint}>
                                    <FormattedMessage
                                        id="dashboard.student.list.access.code.qr.hint"
                                        defaultMessage="Scan QR code or copy the link below"
                                    />
                                </Typography>

                                <Button
                                    style={{ marginTop: '16px' }}
                                    variant={'contained'}
                                    onClick={handleCopyOnboardingUrl}>
                                    <FormattedMessage
                                        id={'dashboard.student.list.copy.onboarding.url'}
                                        defaultMessage={'Copy url'}
                                    />
                                </Button>
                            </React.Fragment>
                        )}
                    </div>
                </DialogContent>

                <DialogActions></DialogActions>
            </Dialog>
        </div>
    )
}

UserAccessCodeModal.propTypes = {}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = (dispatch) => {}

export default connect(mapStateToProps, mapDispatchToProps)(UserAccessCodeModal)
